const setCardTitleHeights = (): void => {

  const grid = document.querySelector('.products-filter-grid')
  if (!grid || !grid.children[0]) return

  const columnsSize = 12
  const span = Number(window.getComputedStyle(grid.children[0]).gridColumnStart.replace(/\D/g,'') )

  const colnums = columnsSize / span
  if (colnums < 2) return
  
  const rows = Math.ceil(grid.children.length / colnums)

  let cid = 0
  for (let ri = 0; ri < rows; ri++) {
    
    const titles: Element[] = []
    const heights: number[] = []

    for (let ci = 0; ci < colnums; ci++) {
      const child = grid.children[cid]
      if (!child) break
      cid++

      const title = child.querySelector('.card-product-title')
      if (!title) continue
      title.removeAttribute('style')
      titles.push(title)
      const height = title.clientHeight
      heights.push(height)
    }

    const maxHeight = Math.max(...heights)
    titles.forEach(title => {
      title.setAttribute('style', `min-height: ${maxHeight}px`)
    })
    
  }

}

export default setCardTitleHeights